jQuery(document).ready(function($){

    function tense_dictionary_search(query) {
        $('.dictionary2__group').show();

        $('.dictionary2__item').hide();
        $('button[data-letter]').removeClass('active');

        var $matches = $('.dictionary2__item').filter(function(index, elem) {
            var title = $(elem).data('title').toLowerCase();
            var query_lower = query.toLowerCase();

            return title.includes(query_lower);
        });
        $matches.slideToggle('fast', function() {
            var $empty_groups = $('.dictionary2__group').filter(function(index, elem) {
                var $visible = $(elem).find('.dictionary2__item').filter(':visible');
                return $visible.length == 0;
            });
            $empty_groups.slideToggle('fast');
        });
        if ($matches.length == 0 ) {
            $('.dictionary2__group:visible').slideToggle('fast');
            $('.dictionary2__notfound').slideToggle('fast');
        } else {
            $('.dictionary2__notfound').hide();
        }
    }

    $('button[data-letter]').click(function() {
        $('.dictionary2__group[data-letter]').hide();
        $('.dictionary2__notfound').hide();
        $('.dictionary2__item').show();
        var letter = $(this).data('letter');
        $('.dictionary2__group[data-letter="' + letter + '"]').slideToggle();
        $('button[data-letter]').removeClass('active');
        $(this).addClass('active');
    });

    $('.dictionary2__nav__button').click(function() {
        $('.dictionary2__nav').slideToggle('fast');
    });

    $('[data-dictionary]').on('change', function() {
        var query = $(this).val();

        if (query) {
            tense_dictionary_search(query);
        }
    });

    $('[data-query]').click(function() {
        tense_dictionary_search($(this).data('query'));
    });

});
